import type { ComponentContentSchema, SlotGroupDefinition } from '@vibesites/runtime';
import { EditableSlotGroup, RichTextContent } from '@vibesites/runtime/react';
import {
  INNER_PAGE_HERO_TITLE_CLASS,
  InnerPageHeroSection,
} from './shared/InnerPageHeroSection';

const bgImageDef: SlotGroupDefinition = {
  label: 'Background Image',
  fields: {
    image: {
      label: 'Image',
      type: 'image',
      defaultField: 'property_featured_image',
    },
    alt: {
      label: 'Alt Text',
      type: 'text',
      defaultValue: 'Sitemap banner',
    },
  },
};


export function SitemapHero() {
  return (
    <InnerPageHeroSection
      bgGroupPath="sitemaphero.bg_image"
      bgImageDef={bgImageDef}
      altFallback="Sitemap banner"
    >
      <RichTextContent
        path="sitemaphero.title"
        as="h1"
        className={INNER_PAGE_HERO_TITLE_CLASS}
      />
      <EditableSlotGroup
        groupPath="sitemaphero.bg_image"
        definition={bgImageDef}
        className="hidden"
        style={{ display: 'none' }}
      >
        <span />
      </EditableSlotGroup>
    </InnerPageHeroSection>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'SitemapHero',
  displayName: 'Sitemap Hero',
  tokens: {
    'sitemaphero.title': {
      label: 'Title',
      type: 'richtext',
      defaultValue: '<p>Sitemap</p>',
    },
  },
  slotGroups: {
    'sitemaphero.bg_image': bgImageDef,
  },
};

(SitemapHero as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default SitemapHero;
